import {useCallback, useEffect, useRef, useState} from "react"
import {useDispatch} from "react-redux"
import {APIStatus} from "scholastic-client-components/src/types/APITypes"
import {authSlice} from "scholastic-client-components/src/slices/authSlice"
import {authAPI, ResetRequest} from "../../api/authAPI"

type SendEmailData = {
    payload: ResetRequest
    onSuccess?: () => void
}

export const useRecoveryEmailAPI = () => {
    const [status, setStatus] = useState<APIStatus>(APIStatus.Initial)
    const dispatch = useDispatch()

    const [secondsLeft, setSecondsLeft] = useState(0)
    const timeoutRef = useRef<number>()

    useEffect(() => {
        return () => {
            clearTimeout(timeoutRef.current)
        }
    }, [])

    useEffect(() => {
        if (secondsLeft) timeoutRef.current = Number(setTimeout(() => {
            setSecondsLeft((seconds) => seconds - 1)
        }, 1000))
    }, [secondsLeft])

    const sendRecoveryEmail = useCallback(
        ({payload, onSuccess}: SendEmailData) => {
            setStatus(APIStatus.Loading)
            dispatch(
                authAPI.reset({
                    onError: (err) => {
                        setStatus(APIStatus.Success)
                        if (err?.response?.status === 429) {
                            setSecondsLeft(err?.retryAfter ?? 60)
                        }
                    },
                    onSuccess: (response) => {
                        setStatus(APIStatus.Success)
                        if (response.nonConfirmedAccount) {
                            dispatch(
                                authSlice.actions.setNonConfirmedAccount(
                                    response.nonConfirmedAccount
                                )
                            )
                        } else {
                            if (onSuccess) onSuccess()
                        }
                    },
                    payload,
                })
            )
        },
        [dispatch]
    )
    return {
        sendRecoveryEmail,
        status,
        secondsLeft,
    }
}
